var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import Toggle from '@web/components/layout/Toggle/Toggle';
import { trpc } from '@web/lib/trpc';
import { classNames } from '@web/utility';
import { buildOrgUnitTree, collectExpandableIds, filterOrgUnitTree, flattenOrgUnitTree, isDefaultOrgUnit } from '@web/utility/orgUnitsTree';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
var OrgUnitsSection = function (_a) {
    var orgUnits = _a.orgUnits, orgUnitsQuery = _a.orgUnitsQuery, selectedOrgUnitId = _a.selectedOrgUnitId, setSelectedOrgUnitId = _a.setSelectedOrgUnitId, refetchOrgUnits = _a.refetchOrgUnits, refetchUsers = _a.refetchUsers;
    var t = useTranslation().t;
    var updateOrgUnitActive = trpc.updateOrgUnitActive.useMutation({
        onSuccess: function () {
            refetchOrgUnits();
            refetchUsers();
        }
    });
    var tree = useMemo(function () {
        return buildOrgUnitTree(orgUnits.map(function (orgUnit) { return ({
            id: orgUnit.id,
            title: orgUnit.title,
            slugId: orgUnit.slugId,
            path: orgUnit.path,
            parentPath: orgUnit.parentPath,
            isActive: orgUnit.isActive,
            type: orgUnit.type
        }); }));
    }, [orgUnits]);
    var filteredTree = useMemo(function () { return filterOrgUnitTree(tree, orgUnitsQuery); }, [tree, orgUnitsQuery]);
    var _b = useState(function () { return new Set(); }), expandedIds = _b[0], setExpandedIds = _b[1];
    useEffect(function () {
        if (orgUnitsQuery.trim()) {
            setExpandedIds(new Set(collectExpandableIds(filteredTree)));
        }
    }, [orgUnitsQuery, filteredTree]);
    var visibleNodes = useMemo(function () { return flattenOrgUnitTree(filteredTree, expandedIds); }, [filteredTree, expandedIds]);
    var toggleExpanded = function (id) {
        setExpandedIds(function (prev) {
            var next = new Set(prev);
            if (next.has(id)) {
                next.delete(id);
            }
            else {
                next.add(id);
            }
            return next;
        });
    };
    return (_jsx("div", __assign({ className: "flex flex-col justify-between gap-5" }, { children: _jsxs("ul", { children: [_jsx("li", __assign({ className: "flex items-start justify-between text-sm mb-5 cursor-pointer", onClick: function () { return setSelectedOrgUnitId(null); } }, { children: _jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsx("div", { className: "w-5 h-5" }), _jsx("span", __assign({ className: classNames('break-all ml-2 mr-1', selectedOrgUnitId === null
                                    ? 'font-semibold text-indigo-500'
                                    : '') }, { children: t('membersFilters.allTeams') }))] })) })), visibleNodes.map(function (unit) {
                    var hasChildren = unit.children.length > 0;
                    var isExpanded = expandedIds.has(unit.id);
                    var isSelected = selectedOrgUnitId === unit.id;
                    return (_jsxs("li", __assign({ className: classNames('flex items-start justify-between text-sm mb-5', isDefaultOrgUnit(unit) ? 'border-t border-gray-200 pt-4' : ''), style: { paddingLeft: "".concat(unit.depth * 16, "px") } }, { children: [_jsxs("div", __assign({ className: "flex min-w-0 cursor-pointer", onClick: function () { return setSelectedOrgUnitId(unit.id); } }, { children: [_jsx("div", __assign({ className: "w-5 h-5 flex-shrink-0", onClick: function (e) {
                                            if (!hasChildren)
                                                return;
                                            e.stopPropagation();
                                            toggleExpanded(unit.id);
                                        } }, { children: hasChildren ? (isExpanded ? (_jsx(ChevronDownIcon, { className: "w-3 h-3 text-gray-400 mt-1" })) : (_jsx(ChevronRightIcon, { className: "w-3 h-3 text-gray-400 mt-1" }))) : null })), _jsx("span", __assign({ className: classNames('break-all ml-2 mr-1', isSelected ? 'font-semibold text-indigo-500' : '') }, { children: unit.title }))] })), _jsx("div", __assign({ onClick: function (e) { return e.stopPropagation(); }, className: "flex-shrink-0" }, { children: _jsx(Toggle, { enabled: unit.isActive, onChange: function () {
                                        return updateOrgUnitActive.mutate({
                                            orgUnitId: unit.id,
                                            isActive: !unit.isActive
                                        });
                                    } }) }))] }), unit.id));
                })] }) })));
};
export default OrgUnitsSection;
